var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),(_vm.data_loaded)?_c('router-view'):_c('div',{staticClass:"loader"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"lds-dual-ring"}),_c('div',[_vm._v("Loading")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }